import { getErrorMessage } from '@nxsys/utils/getErrorMessage';
import { showMessage } from '@nxsys/utils/message';
import { saveFile } from '@nxsys/utils/save-file';
import { getExportDownload } from './api';

const statusOf = (error: unknown) =>
  (error as { response?: { status?: number } })?.response?.status;

// Asks for a fresh link to the file of an export and saves it: a link handed
// out earlier may have expired, and only the user who started the export gets
// one.
export const downloadReportExport = async (exportId: string) => {
  try {
    const { data } = await getExportDownload(exportId);
    saveFile(data.url);
    return true;
  } catch (error) {
    const status = statusOf(error);
    let content = getErrorMessage(error);
    if (status === 404) content = 'This file is not available.';
    else if (status === 409) content = 'The file is not ready yet.';
    showMessage({ type: 'error', content });
    return false;
  }
};
